import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { WebapiService } from 'src/app/shared/services/webapi.service';
declare var $: any;  

@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.scss']
})
export class VideoDetailsComponent implements OnInit,OnChanges {
  @ViewChild('videoFileContainer', { static: false }) videoFileContainer;
  skillSubmitting=false;
  legalitySubmitting=false;
  legalityForm: FormGroup = this.fb.group({
    // email: ['', Validators.compose([Validators.required, Validators.email])],
    // name: ['', Validators.compose([Validators.required])],
    // profession: ['', Validators.compose([Validators.required])],
    message: ['', Validators.compose([Validators.required])]
  }); 

  @Input() videoDetails:any;
  @Input() user:any;
  @Input() modalid:any;

  constructor(private fb: FormBuilder, private toastrService: ToastrService, public webApi: WebapiService, public router: Router) {

    $('body').on('hidden.bs.modal', '.modal', function () {
      $('video').trigger('pause');
    }); 
  }
  

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.videoFileContainer) {
      this.videoFileContainer.nativeElement.load();
      //this.videoFileContainer.nativeElement.play()
    }
  }

  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  getVideoUrl(url : string){
    return  "assets/videos/"+url
  }

  addToFav(videoDetails:any) {  
    
    this.webApi.setLoader(true);
    this.webApi.addVideoToFavourite(videoDetails.id).subscribe((data: any) => {
       if(data.success){
        videoDetails.fav=data.fav
        this.toastrService.success(data.message);
       }
       this.webApi.setLoader(false);
    },
    error => {
      this.webApi.setLoader(false);
      this.toastrService.error("unable to handle response");
    });
  }
  onSubmitLegality(form: FormGroup) {
    if (form.valid && !this.skillSubmitting) {
      this.legalitySubmitting = true;
      form.value.video = this.videoDetails?.name;
      this.webApi.legalityEmail(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          $('#report-legality').modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.legalitySubmitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.legalitySubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  get f1(): { [key: string]: AbstractControl } {
    return this.legalityForm.controls;
  }
}
